import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import React from 'react';
import MenuIcon from '@mui/icons-material/Menu'

export const HamburgerPanelButton = React.memo((props: TopNavBarButtonProps) => (
	<TopNavBarButtonComponent {...props}>
		<MenuIcon fontSize={'small'}/>
		{props.btnDef?.label && <>&nbsp;{props.btnDef?.label}</>}
	</TopNavBarButtonComponent>
));